import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Updates heartbeat of an active stream
 * Updates the heartbeat of an active stream
 * @param streamHistoryId Identifier for stream
 * @returns StreamHistory Successful response
 * @throws ApiError
 */

export var streamHistoryHeartbeat = function streamHistoryHeartbeat(api, streamHistoryId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/stream_history/".concat(streamHistoryId, "/heartbeat");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get URL Appended With Token To Access Non Class Video Conetnt From CDN
 * Return Token which give user's permission to access Video Content
 * * Does user is logged in
 * * Does user has valid subscription which allow them to access this content
 * * Does user is eligible to access beta program content
 * @param id Id for which we need to generate token to access it's video content
 * @param mediaType Type of Media
 * @param mediaFormat File format of media (only used for short movement videos). WebM is default
 * @param requestBody
 * @returns StreamResponse Successful Response
 * @throws ApiError
 */

export var postVideoAssetService = function postVideoAssetService(api, id, mediaType, mediaFormat, requestBody) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/media/".concat(id, "/stream");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof mediaType !== 'undefined') {
    localVarQueryParameter['media_type'] = mediaType;
  }

  if (typeof mediaFormat !== 'undefined') {
    localVarQueryParameter['media_format'] = mediaFormat;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * @deprecated
 * Get an Akamai token for iOS
 * Get an Akamai token for iOS based on the logged in user's subscription
 * @returns IOSAkamaiToken Successful response
 * @throws ApiError
 */

export var getIosAkamaiToken = function getIosAkamaiToken(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/video/ios/akamai_token";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get URL Appended With Token To Access Ride Video Conetnt From CDN For internal services
 * Return Token which give user's permission to access Video Content of Requested Ride for
 * 1 minutes if all following validation passed
 * * Does user is logged in
 * * Does user has valid subscription which allow them to access this content
 * * Does ride is available in user’s availability zone
 * * Does ride is on-demand or not while generating token for on-demand ride
 * * Does ride is live while generating token for live ride
 * * Does user is eligible to access beta program content
 * @param pelotonTotpToken An 8-digit TOTP (time-based HMAC one-time password) using SHA1. Please contact the API team for
 * the shared secret.
 *
 * @param joinToken active class identifier
 * @param rideType Type of Ride
 * @param requestBody
 * @returns InternalStreamResponse Successful Response
 * @throws ApiError
 */

export var postVideoAssetService1 = function postVideoAssetService1(api, pelotonTotpToken, joinToken, rideType, requestBody) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/internal/ride/".concat(joinToken, "/stream");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof rideType !== 'undefined') {
    localVarQueryParameter['ride_type'] = rideType;
  }

  localVarHeaderParameter['Peloton-TOTP-Token'] = String(pelotonTotpToken);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * @deprecated
 * Get an Akamai token for Peloton Hardware
 * Get an Akamai token for Peloton Hardware Based on logged in user's
 * subscription and device from session
 * @returns IOSAkamaiToken Successful response
 * @throws ApiError
 */

export var getVideoAssetService = function getVideoAssetService(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/video/bike/akamai_token";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get URL Appended With Token To Access Ride Video Conetnt From CDN
 * Return Token which give user's permission to access Video Content of Requested Ride for
 * 1 minutes if all following validation passed
 * * Does user is logged in
 * * Does user has valid subscription which allow them to access this content
 * * Does ride is available in user’s availability zone
 * * Does ride is on-demand or ride has premiere in progress while generating token for on-demand ride
 * * Does ride is live while generating token for live ride
 * * Does user is eligible to access beta program content
 * @param rideId Id of ride for which we need to generate token to access it's video content
 * @param contentType Type of Ride
 * @param streamSource Type of Stream
 * @param streamUrlType Use default or Lamina url
 * @param requestBody
 * @returns ClassMediaStreamResponse Successful Response
 * @throws ApiError
 */

export var postVideoAssetService2 = function postVideoAssetService2(api, rideId, contentType, streamSource, streamUrlType, requestBody) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var localVarPath = "/api/ride/".concat(rideId, "/stream");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof contentType !== 'undefined') {
    localVarQueryParameter['content_type'] = contentType;
  }

  if (typeof streamSource !== 'undefined') {
    localVarQueryParameter['stream_source'] = streamSource;
  }

  if (typeof streamUrlType !== 'undefined') {
    localVarQueryParameter['stream_url_type'] = streamUrlType;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get URL Appended With Token To Access Playback Video Conetnt From CDN For internal services
 * Return Token which give user's permission to access Content of Requested Ride for
 * 1 minutes if all following validation passed
 * * Does user is logged in
 * * Does user has valid subscription which allow them to access this content
 * @param pelotonTotpToken An 8-digit TOTP (time-based HMAC one-time password) using SHA1. Please contact the API team for
 * the shared secret.
 *
 * @param playbackId Id of Playback for which we need to generate token to access its video content
 * @param requestBody
 * @returns StreamResponse Successful Response
 * @throws ApiError
 */

export var postVideoAssetService3 = function postVideoAssetService3(api, pelotonTotpToken, playbackId, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/internal/playback/".concat(playbackId, "/stream");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-TOTP-Token'] = String(pelotonTotpToken);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Returns specific device video
 * Returns specific device video. Uses user auth or device certs
 * for authentication.
 * @param deviceVideoId Identifier for device_video
 * @param requestBody
 * @returns StreamResponse Successful Response
 * @throws ApiError
 */

export var postVideoAssetService4 = function postVideoAssetService4(api, deviceVideoId, requestBody) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/device_videos/".concat(deviceVideoId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get URL Appended With Token To Access Ride Video Conetnt From CDN
 * Return Tokennized URL which give studio application permission to access Live Stream of Requested Ride for
 * 1 minutes if all following validation passed
 * * Does ride is live while generating token for ride
 * * Does oauth token have studio read scope
 * @param rideId Id of ride for which we need to generate token to access it's video content
 * @returns StreamResponse Successful Response
 * @throws ApiError
 */

export var postVideoAssetService5 = function postVideoAssetService5(api, rideId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/studio/ride/".concat(rideId, "/stream");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets the stream URL for the class by ID
 * Gets the stream URL for the class. The ID is "<class_id>-<class_type>".
 * @param id ID for the class' stream
 * @returns ClassStream Class stream object
 * @throws ApiError
 */

export var getStream = function getStream(api, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/stream/<id>";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof id !== 'undefined') {
    localVarQueryParameter['id'] = id;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * @deprecated
 * Get an authentication token used for initiating a new movements stream
 * Get an authentication token used for initiating a new movements stream.
 * @returns any Successful response
 * @throws ApiError
 */

export var getMovementsStreamToken = function getMovementsStreamToken(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/api/subscription/movements_stream";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * @deprecated
 * Get an authentication token used for initiating a new stream
 * Get an authentication token used for initiating a new stream.  The
 * endpoint will validate that the user has a valid device or
 * subscription and enforce stream limits
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var getSubscriptionStreamToken = function getSubscriptionStreamToken(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/subscription/stream";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Delete stream history by id
 * Delete a stream history record by id. When client ends a stream, the client would call this to free up the available stream associated to the subscription
 * @param streamHistoryId Identifier for stream
 * @returns any Successful response
 * @throws ApiError
 */

export var deleteStreamHistory = function deleteStreamHistory(api, streamHistoryId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/stream_history/".concat(streamHistoryId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'DELETE'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Returns device videos for a specific platfom.
 * Returns device videos for a specific platform. Uses user auth or device certs
 * for authentication.
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param contentType Content type of the device videos
 * @param requestBody
 * @returns StreamResponse Successful Response
 * @throws ApiError
 */

export var postVideoAssetService6 = function postVideoAssetService6(api, pelotonPlatform, contentType, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/device_videos";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof contentType !== 'undefined') {
    localVarQueryParameter['content_type'] = contentType;
  }

  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};